/**
 * Shared constants for the Scratching Post SPA.
 * Centralises magic strings and numbers that are referenced across
 * multiple client-side modules.
 *
 * @module constants
 */

// -- Storage keys ------------------------------------------------------------

/** sessionStorage key used to pass the userId between login pages. */
export const SK_LOGIN_USER_ID  = 'sp_login_userId';

/** sessionStorage key used to pass the emailId between login pages. */
export const SK_LOGIN_EMAIL_ID = 'sp_login_emailId';

// -- Input length limits -----------------------------------------------------

/** Maximum length for a username. */
export const MAX_USERNAME_LENGTH = 40;

/** Maximum length for an email address (RFC 5321 path limit). */
export const MAX_EMAIL_LENGTH = 254;

/** Maximum length for a password. */
export const MAX_PASSWORD_LENGTH = 128;

/** Number of digits in a login code. */
export const CODE_LENGTH = 6;

// -- Password validation -------------------------------------------------------

/** Minimum number of characters required in a password. */
export const MIN_PASSWORD_LENGTH = 10;

// -- API key limits ------------------------------------------------------------

/** Maximum length for an API key description. */
export const MAX_API_KEY_DESC_LENGTH = 200;

// -- Session refresh -----------------------------------------------------------

/** Seconds before session expiration to trigger a refresh (clock-skew buffer). */
export const CLOCK_SKEW_BUFFER_S = 60;

// -- Dashboard ----------------------------------------------------------------

/** Ordered list of scanner decision types (matches the DB enum). */
export const DECISION_TYPES = [
  'allow',
  'allow_with_tags',
  'redact',
  'constrain',
  'require_approval',
  'block',
];

/** Color assigned to each decision type for chart rendering. */
export const DECISION_COLORS = {
  allow:            '#22c55e',
  allow_with_tags:  '#06b6d4',
  redact:           '#f59e0b',
  constrain:        '#ec4899',
  require_approval: '#a855f7',
  block:            '#ef4444',
};

/** Ordered list of LLM token series for chart rendering. */
export const TOKEN_TYPES = ['inputTokens', 'outputTokens'];

/** Color assigned to each token series for chart rendering. */
export const TOKEN_COLORS = {
  inputTokens:  '#3b82f6',
  outputTokens: '#f97316',
};

/** Available time-interval choices for the dashboard. */
export const TIME_INTERVALS = ['hour', 'day', 'week', 'month'];

// -- Themes -------------------------------------------------------------------

/** Available visual themes. */
export const THEMES = ['light', 'dark'];

// -- Help topic slugs ---------------------------------------------------------

/** Slug for the agent lifecycle verification help topic. */
export const HELP_TOPIC_AGENT_LIFECYCLE = 'agent-lifecycle-verification';

/** Slug for the disable-plugin help topic. */
export const HELP_TOPIC_DISABLE_PLUGIN = 'disable-plugin';

/** Slug for the view-plugin-logs help topic. */
export const HELP_TOPIC_VIEW_PLUGIN_LOGS = 'view-plugin-logs';

/** Slug for the view-workspaces-and-agents help topic. */
export const HELP_TOPIC_VIEW_WORKSPACES = 'view-workspaces-and-agents';
